import React, { useMemo } from 'react';
import { StatCard } from '@onward-delivery/design';
import { formatStatValue, lowStockCount } from './utils';

const StatCards = ({ summary, skus, loading, skusLoading, error }) => {
    const lowStock = useMemo(() => lowStockCount(skus), [skus]);

    if (error) {
        return null;
    }

    const status = { loading, error };
    // Three cards read the kpi view; this one is derived from the sku rows, which
    // are a separate query. Sharing the summary's flag rendered a confident "0
    // low-stock alerts" for however long the rollup took to arrive after it.
    const skuStatus = { loading: skusLoading, error };

    return (
        <div className="grid shrink-0 grid-cols-2 gap-4 pb-4 md:grid-cols-4">
            <StatCard
                variant="metric"
                tone="warning"
                label="Inbound items"
                value={formatStatValue(summary?.inbound_count, status)}
            />
            <StatCard
                variant="metric"
                tone="primary"
                label="Items On hand"
                value={formatStatValue(summary?.on_hand_count, status)}
            />
            <StatCard
                variant="metric"
                tone="info"
                label="Outbound Items"
                value={formatStatValue(summary?.outbound_count, status)}
            />
            <StatCard
                variant="metric"
                tone="destructive"
                label="Low-stock alerts"
                value={formatStatValue(skus?.length ? lowStock : undefined, skuStatus)}
                className="border-destructive/30 bg-destructive/5"
            />
        </div>
    );
};

export default StatCards;
